
import { defineComponent, computed } from 'vue'
import { useRoute } from 'vue-router/composables'
import NavigationDrawer from '@/components/NavigationDrawer.vue'
import SideNavLink from '@/components/SideNavLink.vue'
import SettingsDisabledApps from '@/components/SettingsDisabledApps.vue'

export default defineComponent({
  components: {
    NavigationDrawer,
    SideNavLink,
    SettingsDisabledApps
  },

  setup () {
    const route = useRoute()
    const currentView = computed<string>(() => route.name || '')

    return {
      currentView
    }
  }
})
